import { render, staticRenderFns } from "./characteristic-title.vue?vue&type=template&id=2c86c3ff&scoped=true&"
import script from "./characteristic-title.vue?vue&type=script&lang=ts&"
export * from "./characteristic-title.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c86c3ff",
  null
  
)

export default component.exports